<div class="row">
  <mat-form-field class="w-65 m-r-1" subscriptSizing="dynamic">
    <mat-label>{{ monthLabel }}</mat-label>
    <mat-select
      [formControl]="selectedMonthCtrl"
      (selectionChange)="onSelectedItemChange()"
    >
      <mat-option *ngFor="let month of months" [value]="month.code">{{
        month.value | translate
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="w-35" subscriptSizing="dynamic">
    <mat-label>{{ yearLabel }}</mat-label>
    <mat-select
      [formControl]="selectedYearCtrl"
      (selectionChange)="onSelectedItemChange()"
    >
      <mat-option *ngFor="let year of years$ | async" [value]="year">{{
        year
      }}</mat-option>
    </mat-select>
  </mat-form-field>
</div>
